var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "EmdFormGroup",
    {
      attrs: {
        label: _vm.$t("professional-occupation"),
        state: _vm.getState(_vm.$v.recipient.professional_occupation),
        feedbacks: _vm.feedbacks(_vm.$v.recipient.professional_occupation),
        required: "",
      },
    },
    [
      _c("EmdInput", {
        attrs: {
          name: "professional-occupation",
          readonly: _vm.disabled,
          disabled: _vm.disabled,
        },
        on: { input: () => _vm.$v.recipient.professional_occupation.$touch() },
        model: {
          value: _vm.recipient.professional_occupation,
          callback: function ($$v) {
            _vm.$set(_vm.recipient, "professional_occupation", $$v)
          },
          expression: "recipient.professional_occupation",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }